module.exports = __webpack_public_path__ + "static/media/banner-right-02.2b89831b.gif";